var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MCS',{attrs:{"company-id":_vm.companyId,"agent-id":_vm.userId},on:{"closeConnect":_vm.closeConnect}})
}
var staticRenderFns = []

export { render, staticRenderFns }